<template>
  <div>
    <div v-if="is_url_expiration == false && url_signed == false">
      <div class="flex justify-center" v-if="loading">
        <propagate-loader
          class="spinner"
          color="#9D4536"
          :loading="loading"
          :size="50"
        ></propagate-loader>
      </div>
      <!-- PARTNER DATA SECCION INIT -->
      <div class="flex flex-wrap">
        <div class="headers">
          <h2>Datos del Socio</h2>
        </div>
        <div class="partner-col" v-for="data in partner_data" :key="data.label">
          <p class="text-brown">{{ data.label }}</p>
          <p class="font-semibold">{{ data.value }}</p>
        </div>
      </div>
      <!-- BENEFTIS SECCION INIT -->
      <div class="w-full bg-goodGreen">
        <h2 class="headers">Beneficios de FOMAPO</h2>
      </div>
      <div class="w-full">
        <!-- headers -->
        <div class="benefitsFOMAPO-hearders hideInSmallScreens">
          <div class="md:inline-grid">
            <p class="text-brown">Beneficios</p>
          </div>
          <div class="md:inline-grid text-center">
            <p class="text-brown">Monto</p>
          </div>
          <div class="md:inline-grid text-center">
            <p class="text-brown">Aportación Qnal.</p>
          </div>
          <div class="md:inline-grid text-center">
            <p class="text-brown">Acepto</p>
          </div>
        </div>

        <div class="benefitsFOMAPO-hearders">
          <div>
            <!--movil-->
            <p class="benefitsFOMAPO-hearders-movil">Beneficio</p>
            <!--movil end-->
            <p class="font-semibold">Básicos</p>
          </div>
          <div class="text-center">
            <p class="benefitsFOMAPO-hearders-movil">Monto</p>
            <p class="font-semibold">{{ basic_until_70 }}</p>
          </div>
          <div class="text-center mt-2">
            <p class="benefitsFOMAPO-hearders-movil">Aportación Qnal.</p>
            <p class="font-semibold md:mt-2">
            <!--{{ basic_ammount_fortnightly }}-->
            </p>
          </div>
          <div class="text-center mt-2">
            <p class="benefitsFOMAPO-hearders-movil">Acepto</p>
            <p class="font-semibold md:mt-2">{{  }}</p>
          </div>

          <div class="mt-5">
            <p class="benefitsFOMAPO-hearders-movil">Beneficio</p>
            <p class="font-semibold">Colaterales</p>
            <p class="ml-5">Bono Anual (A partir de 70 años como jubilado)</p>
            <p class="ml-5 mt-1">Prótesis (Solo por única ocasión)</p>
            <p class="ml-5 mt-1">
              Lentes (Una vez al año, 3 veces como máximo)
            </p>
            <p class="ml-5 mt-2">Pérdida Orgánica</p>
          </div>
          <div class="text-center mt-5 font-semibold">
            <p class="benefitsFOMAPO-hearders-movil">Monto</p>
            <p class="mt-5">{{ collateral_bonus_annual }}</p>
            <p class="mt-10 md:mt-8 xl:mt-2">{{ collateral_prothesis }}</p>
            <p class="mt-14 md:mt-5 xl:mt-2">{{ collateral_glasses }}</p>
            <p class="mt-14 md:mt-5 xl:mt-2">{{ collateral_lost_organic }}</p>
          </div>
          <div class="text-center mt-3">
            <p class="benefitsFOMAPO-hearders-movil">Aportación Qnal.</p>
            <p class="font-semibold md:mt-20">
              {{basic_ammount_fortnightly}}<!--{{ collateral_ammount_fortnightly }}-->
            </p>
          </div>
          <div class="text-center mt-3">
            <p class="benefitsFOMAPO-hearders-movil">Acepto</p>
            <p class="font-semibold my-20">
              {{ "SI" }}
            </p>
          </div>

          <div>
            <p class="font-semibold mt-5">
              Gastos Funerales Dependientes Económicos
            </p>
          </div>
          <div class="text-center mt-5">
            <p class="benefitsFOMAPO-hearders-movil">Monto</p>
            <p class="font-semibold">{{gastos_funerarios_suma_asegurada}}</p>
          </div>
          <div class="text-center mt-4">
            <p class="benefitsFOMAPO-hearders-movil">Aportación Qnal.</p>
            <!--<p class="font-semibold">{{gastos_funerarios_aportacion_quincenal}}</p>-->
          </div>
          <div class="text-center">
            <p class="benefitsFOMAPO-hearders-movil">Acepto</p>
            <p class="font-semibold md:mt-4">
            <!--{{ collateral_expenses_funeral_accept }}-->
            </p>
          </div>

          <div class="mt-5">
            <p class="benefitsFOMAPO-hearders-movil">Beneficio</p>
            <p class="font-semibold text-left">COVID-19</p>
            <p class="ml-5">Fallecimiento por COVID</p>
            <p class="ml-5">Fallecimiento otro motivo</p>
            <p class="ml-5">
              Hospitalización por COVID o diagnóstico de Enfermedad grave
            </p>
          </div>
          <div class="text-center mt-5">
            <p class="benefitsFOMAPO-hearders-movil">Monto</p>
            <p class="font-semibold mt-5">$50,000.00</p>
            <p class="font-semibold mt-6 md:mt-0">$25,000.00</p>
            <p class="font-semibold mt-6 md:mt-0">$15,000.00</p>
          </div>
          <div class="text-center mt-2">
            <p class="benefitsFOMAPO-hearders-movil">Aportación Qnal.</p>
            <p class="font-semibold md:mt-16">
              {{ covid_ammount_fortnightly }}
            </p>
          </div>
          <div class="text-center mt-2">
            <p class="benefitsFOMAPO-hearders-movil">Acepto</p>
            <p class="font-semibold md:mt-16">{{ covid_accept }}</p>
          </div>
          
        </div>
      </div>
      <!-- Beneficios de FOMAPO SECCION END -->
      <!-- Beneficios por Sobrevivencia SECCION INIT -->
      <div class="w-full bg-goodGreen">
        <div class="m-4">
          <h1 class="text-3xl text-left text-white">
            Beneficios por Sobrevivencia
          </h1>
        </div>
      </div>
      <!-- Beneficios de Sobrevivencia DATA INIT -->
      <div class="w-full">
        <div class="">
          <!-- HEADERS NAME INIT -->
          <div
            class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 m-4"
          >
            <div
              class="md:inline-grid lg:inline-grid xl:inline-grid hidden text-left"
            >
              <p class="text-brown">Beneficios Adicionales</p>
            </div>
            <div
              class="md:inline-grid lg:inline-grid xl:inline-grid hidden text-center"
            >
              <p class="text-brown">Fecha de Adquisición</p>
            </div>
            <div
              class="md:inline-grid lg:inline-grid xl:inline-grid hidden text-center"
            >
              <p class="text-brown">Monto</p>
            </div>
            <div
              class="md:inline-grid lg:inline-grid xl:inline-grid hidden text-center"
            >
              <p class="text-brown">Aportación Qnal.</p>
            </div>
            <div
              class="md:inline-grid lg:inline-grid xl:inline-grid hidden text-center"
            >
              <p class="text-brown">Acepto</p>
            </div>
          </div>
          <!-- HEADERS NAME END -->
          <!-- DATA INIT -->
          <div
            class="grid sm:grid-cols-2 md:grid-cols-5 lg:grid-cols-5 xl:grid-cols-5 m-4"
          >
            <div class="md:flex lg:flex xl:flex hidden">
              <div class="w-1/4 text-center">
                <p
                  v-for="(benefit, index) in benefits"
                  :key="benefit.id"
                  class="pt-2 font-semibold mb-8"
                >
                  {{ index + 1 }}
                </p>
              </div>
              <div class="w-3/4 text-left">
                <p
                  v-for="benefit in benefits"
                  :key="benefit.id"
                  class="font-semibold mb-4"
                >
                  Defunción<br />
                  <span class="font-semibold">Recuperación</span>
                </p>
              </div>
            </div>
            <div class="md:flex lg:flex xl:flex hidden text-center">
              <div class="w-full">
                <p v-for="benefit in benefits" :key="benefit.id" class="mb-4">
                  {{ benefit.sobrevivencia_fecha_adquisicion }}
                  <br />
                  <span>
                    {{ benefit.sobrevivencia_recuperacion }}
                  </span>
                </p>
              </div>
            </div>
            <div class="md:block lg:block xl:block hidden text-center">
              <div class="w-full">
                <p v-for="benefit in benefits" :key="benefit.id" class="mb-4">
                  {{ benefit.sobrevivencia_monto }}
                  <br />
                  <span class="font-semibold pr-4">V.A.P.</span>
                  <span class="text-right">{{
                    benefit.sobrevivencia_vap
                  }}</span>
                </p>
              </div>
            </div>
            <div class="md:flex lg:flex xl:flex hidden text-center">
              <div class="w-full">
                <p v-for="benefit in benefits" :key="benefit.id" class="mb-10">
                  {{ benefit.sobrevivencia_aportacion_quincenal }}
                </p>
              </div>
            </div>
            <div class="md:flex lg:flex xl:flex hidden text-center">
              <div class="w-full">
                <p v-for="benefit in benefits" :key="benefit.id" class="mb-4">
                  {{ benefit.sobrevivencia_acepto }}
                  <br />
                  <span class="font-semibold pr-4">Invalidez</span>
                  <span class="text-right">Si Aplica</span>
                </p>
              </div>
            </div>
            <!-- Data Mobile Init -->
            <div
              class="md:hidden lg:hidden xl:hidden centerInSmallScreens w-full justify-center"
            >
              <div
                v-for="(benefit, index) in benefits"
                :key="benefit.id"
                class="grid grid-cols-2 text-center"
              >
                <div class="">
                  <div class="w-full text-brown">
                    <p>Beneficios</p>
                  </div>
                  <div class="w-full mt-3 font-semibold">
                    <p class="font-semibold">
                      <span class="text-brown">{{ index + 1 }} </span>Defunción
                    </p>
                  </div>
                  <div class="w-full mt-5">
                    <p class="text-brown mt-5">Monto</p>
                    <p>{{ benefit.sobrevivencia_monto }}</p>
                  </div>
                  <div class="w-full mt-5">
                    <p class="font-semibold text-brown">Acepto</p>
                    <p>{{ benefit.sobrevivencia_acepto }}</p>
                  </div>
                  <div class="w-full mt-5 mb-5">
                    <p class="font-semibold">V.A.P</p>
                    <p>{{ benefit.sobrevivencia_vap }}</p>
                  </div>
                </div>
                <div class="">
                  <div class="w-full text-brown">
                    <p>Fecha de Adquisición</p>
                  </div>
                  <div class="w-full mt-3">
                    <p>{{ benefit.sobrevivencia_fecha_adquisicion }}</p>
                  </div>
                  <div class="w-full mt-5">
                    <p class="text-brown">Aportación Qnal.</p>
                    <p>{{ benefit.sobrevivencia_aportacion_quincenal }}</p>
                  </div>
                  <div class="w-full mt-5">
                    <p class="font-semibold">Recuperación</p>
                    <p>{{ benefit.sobrevivencia_recuperacion }}</p>
                  </div>
                  <div class="w-full mt-5">
                    <p class="font-semibold">Invalidez</p>
                    <p>{{ benefit.sobrevivencia_invalidez }}</p>
                  </div>
                </div>
              </div>
            </div>
            <!-- Data Mobile End -->
          </div>
          <!-- DATA END -->
        </div>
      </div>
      <!-- Beneficios de Sobrevivencia SECCION END -->

      <!-- Beneficios por Salud SECCION INIT -->
      <div class="w-full bg-goodGreen">
        <div class="m-4">
          <h1 class="text-3xl text-left text-white">Beneficios de Salud</h1>
        </div>
      </div>
      <div class="w-full">
        <div class="">
          <!-- DATA INIT -->
          <!-- Big Screens-->
          <div class="hideInSmallScreens ml-5">
            <!-- HEADERS-->
            <div class="flex text-brown h-12 text-center">
              <div class="w-1/5"><p>Beneficios</p></div>
              <div class="w-1/5"><p>Módulos</p></div>
              <div class="w-1/5"><p>Protección</p></div>
              <div class="w-1/5"><p>Fecha Alta</p></div>
              <div class="w-1/5"><p>Aportación Qnal.</p></div>
            </div>
            <!-- One row -->
            <div class="flex">
              <div class="w-full font-semibold">
                <p>Cáncer</p>
              </div>
            </div>
            <!-- Two rows -->
            <div class="flex">
              <div class="w-1/5 ml-5"><p>Socio</p></div>
              <div class="w-1/5 text-center">
                <p>
                  {{
                    cancer_partner_modules == "." ? "" : cancer_partner_modules
                  }}
                </p>
              </div>
              <div class="w-1/5 text-center">
                {{
                  cancer_partner_protection == "."
                    ? ""
                    : cancer_partner_protection
                }}
              </div>
              <div class="w-1/5 text-center">
                {{
                  cancer_partner_date_register == "."
                    ? ""
                    : cancer_partner_date_register
                }}
              </div>
              <div class="w-1/5 text-center">
                {{
                  cancer_partner_ammount_fortnightly == "."
                    ? ""
                    : cancer_partner_ammount_fortnightly
                }}
              </div>
            </div>
            <!-- Three rows -->
            <div class="flex">
              <div class="w-1/5 h-auto ml-5">
                <p>Dependientes Económicos</p>
              </div>
              <div class="w-3/5 h-auto text-xs">
                <p
                  v-for="cancer_dependients in cancer_economic_dependients"
                  :key="cancer_dependients.index"
                >
                  {{ cancer_dependients }}
                </p>
              </div>
            </div>
            <!-- Four rows -->
            <div class="flex ml-5">
              <div class="w-1/5"><p>Observaciones</p></div>
              <div class="w-3/5">
                {{ cancer_observations == "." ? "" : cancer_observations }}
              </div>
            </div>
            <!-- Five rows -->
            <div class="flex">
              <div class="w-full font-semibold">Enfermedades Graves Socio</div>
            </div>
            <!-- Six rows -->
            <div class="flex">
              <div class="w-1/5 ml-5">Socio</div>
              <div class="w-1/5 text-center">
                {{ eg_partner_modules == "." ? "" : eg_partner_modules }}
              </div>
              <div class="w-1/5 text-center">
                {{ eg_partner_protection == "." ? "" : eg_partner_protection }}
              </div>
              <div class="w-1/5 text-center">
                {{
                  eg_partner_date_register == "."
                    ? ""
                    : eg_partner_date_register
                }}
              </div>
              <div class="w-1/5 text-center">
                {{
                  eg_partner_ammount_fortnightly == "."
                    ? ""
                    : eg_partner_ammount_fortnightly
                }}
              </div>
            </div>
            <!-- Seven rows -->
            <div class="flex text-right">
              <div class="w-4/5"></div>
              <div class="w-1/5"><hr class="font-semibold" /></div>
            </div>
            <!-- Eight rows -->
            <div class="flex text-center">
              <div class="w-3/5"></div>
              <div class="w-1/5 text-brown"><p>Aportación Total</p></div>
              <div class="w-1/5 font-semibold">
                <p>{{ ammount_total_benefits }}</p>
              </div>
            </div>
          </div>

          <!-- Data Mobile Init -->
          <div class="showInSmallScreens ml-5">
            <!-- One row -->
            <div class="flex text-brown">
              <div class="w-1/2"><p>Beneficios</p></div>
              <div class="w-1/2"><p>Módulos</p></div>
            </div>
            <!-- Two row -->
            <div class="flex">
              <div class="w-full font-semibold">
                <p>Cáncer</p>
              </div>
            </div>
            <!-- Three row -->
            <div class="flex ml-5">
              <div class="w-1/2"><p>Socio</p></div>
              <div class="w-1/2">
                <p>
                  {{
                    cancer_partner_modules == "." ? "" : cancer_partner_modules
                  }}
                </p>
              </div>
            </div>
            <!-- Four row -->
            <div class="flex ml-5">
              <div class="w-full"><p>Dependientes Económicos</p></div>
            </div>
            <!-- Five row -->
            <div class="">
              <div
                class="w-full text-xs h-auto ml-5 pr-5"
                v-for="cancer_dependients in cancer_economic_dependients"
                :key="cancer_dependients.index"
              >
                <p>
                  {{ cancer_dependients }}
                </p>
              </div>
            </div>
            <!-- Six row -->
            <div class="flex text-brown mt-5">
              <div class="w-1/2"><p>Protección</p></div>
              <div class="w-1/2"><p>Fecha de Alta</p></div>
            </div>
            <!-- Seven row -->
            <div class="flex font-semibold">
              <div class="w-1/2">
                <p>
                  {{
                    cancer_partner_protection == "."
                      ? ""
                      : cancer_partner_protection
                  }}
                </p>
              </div>
              <div class="w-1/2">
                <p>
                  {{
                    cancer_partner_date_register == "."
                      ? ""
                      : cancer_partner_date_register
                  }}
                </p>
              </div>
            </div>
            <!-- Eight row -->
            <div class="flex text-brown text-center mt-5">
              <div class="w-full"><p>Aportación Quincenal</p></div>
            </div>
            <!-- Nine row -->
            <div class="flex font-semibold text-center">
              <div class="w-full">
                <p>
                  {{
                    cancer_partner_ammount_fortnightly == "."
                      ? ""
                      : cancer_partner_ammount_fortnightly
                  }}
                </p>
              </div>
            </div>
            <!-- Ten row -->
            <div class="flex text-brown">
              <div class="w-full"><p>Observaciones</p></div>
            </div>
            <!-- Eleven row -->
            <div class="flex">
              <div class="w-full">
                <p>
                  {{ cancer_observations == "." ? "" : cancer_observations }}
                </p>
              </div>
            </div>
            <div class="flex text-brown mt-5">
              <div class="w-1/2"><p>Beneficios</p></div>
              <div class="w-1/2"><p>Módulos</p></div>
            </div>
            <!-- Twelve row -->
            <div class="flex">
              <div class="w-full font-semibold">Enfermedades Graves</div>
            </div>
            <!-- Thirteen row -->
            <div class="flex ml-5">
              <div class="w-1/2"><p>Socio</p></div>
              <div class="w-1/2">
                <p>{{ eg_partner_modules == "." ? "" : eg_partner_modules }}</p>
              </div>
            </div>
            <!-- Fourteen row -->
            <div class="flex text-brown mt-5">
              <div class="w-1/2"><p>Protección</p></div>
              <div class="w-1/2"><p>Fecha de Alta</p></div>
            </div>
            <!-- Fiveteen row -->
            <div class="flex font-semibold">
              <div class="w-1/2">
                <p>
                  {{
                    eg_partner_protection == "." ? "" : eg_partner_protection
                  }}
                </p>
              </div>
              <div class="w-1/2">
                <p>
                  {{
                    eg_partner_date_register == "."
                      ? ""
                      : eg_partner_date_register
                  }}
                </p>
              </div>
            </div>
            <!-- Sixteen row -->
            <div class="flex text-brown text-center mt-5">
              <div class="w-full"><p>Aportación Quincenal</p></div>
            </div>
            <!-- Seventeen row -->
            <div class="flex font-semibold text-center">
              <div class="w-full">
                <p>
                  {{
                    eg_partner_ammount_fortnightly == "."
                      ? ""
                      : eg_partner_ammount_fortnightly
                  }}
                </p>
              </div>
            </div>
            <!-- Eighteen rows -->
            <div class="flex text-right mt-5">
              <div class="w-full"><hr class="font-semibold" /></div>
            </div>
            <!-- Nineteen rows -->
            <div class="flex text-center">
              <div class="w-full text-brown"><p>Aportación Total</p></div>
            </div>
            <!-- Tweenty rows -->
            <div class="flex text-center">
              <div class="w-full font-semibold">
                <p>{{ ammount_total_benefits }}</p>
              </div>
            </div>
          </div>
          <!-- MOVIL END -->
          <!-- DATA END -->
        </div>
      </div>
      <!-- Beneficios de salud END -->
      <!-- Beneficiarios por fallecimiento del Socio SECCION INIT -->
      <div class="w-full bg-goodGreen">
        <div class="m-4">
          <h1 class="text-3xl text-left text-white">
            Beneficiarios por fallecimiento del Socio
          </h1>
        </div>
      </div>
      <!-- DATA INIT -->
      <div class="showInSmallScreens text-center">
        <!-- Data Mobile Init -->
        <div
          class="ml-2 mr-2 lg:ml-5 xl:ml-20 mt-5 lg:flex-wrap justify-center"
        >
          <div
            class="w-full"
            v-for="beneficiaries in beneficiariesDecease"
            :key="beneficiaries.id"
          >
            <div class="w-full mt-5 text-left">
              <p class="text-brown">Nombre</p>
              <p class="font-semibold">{{ beneficiaries.nombres }}</p>
            </div>

            <div class="w-full inline-flex mt-5">
              <div class="w-1/2">
                <p class="text-brown">Fecha de Nacimiento</p>
                <p class="font-semibold">
                  {{ beneficiaries.fecha_nacimiento }}
                </p>
              </div>

              <div class="w-1/2">
                <p class="text-brown text-center">Parentesco</p>
                <p class="font-semibold text-center">
                  {{ beneficiaries.parentesco }}
                </p>
              </div>
            </div>

            <div class="w-full mt-5">
              <p class="text-goodGreen text-center">Porcentaje (%)</p>
              <p class="font-semibold text-center">
                {{ beneficiaries.porcentaje }}
              </p>
            </div>
          </div>
        </div>
        <!-- Data Mobile End-->
      </div>
      <div>
        <div class="hideInSmallScreens">
          <div class="ml-20 mt-5 flex flex-wrap justify-center">
            <div class="w-1/4">
              <p class="text-goodGreen">Nombres</p>
              <p
                class="font-semibold"
                v-for="beneficiaries in beneficiariesDecease"
                :key="beneficiaries.id"
              >
                {{ beneficiaries.nombres }}
              </p>
            </div>

            <div class="w-1/4">
              <p class="text-goodGreen text-center">Fecha de Nacimiento</p>
              <p
                class="font-semibold text-center"
                v-for="beneficiaries in beneficiariesDecease"
                :key="beneficiaries.id"
              >
                {{ beneficiaries.fecha_nacimiento }}
              </p>
            </div>

            <div class="w-1/4">
              <p class="text-goodGreen text-center">Parentesco</p>
              <p
                class="font-semibold text-center"
                v-for="beneficiaries in beneficiariesDecease"
                :key="beneficiaries.id"
              >
                {{ beneficiaries.parentesco }}
              </p>
            </div>

            <div class="w-1/4">
              <p class="text-goodGreen text-center">%</p>
              <p
                class="font-semibold text-center"
                v-for="beneficiaries in beneficiariesDecease"
                :key="beneficiaries.id"
              >
                {{ beneficiaries.porcentaje }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full">
        <div class="">
          <hr
            class="md:block lg:block xl:block hidden mt-10 bg-goodGreen h-px mx-24"
          />
          <div class="mt-10 px-10 lg:px-24">
            <p class="text-xl text-center lg:text-left">
              Todos los Beneficios aplican en los tiempos del Reglamento del
              Fondo Magisterial Potosito para los Agremiados a la Sección 26 del
              Sindicato Nacional de los Trabajadores de la Educación en el
              Estado de San Luis Potosí.
            </p>
          </div>
          <div class="text-center mt-10 mb-10 px-10 items-center">
            <span>He leído y acepto las condiciones del </span
            ><a
              class="text-goodGreen"
              href=""
              v-on:click.prevent="getPrivacynotice()"
              >Aviso de Privacidad</a
            >
          </div>
          <div class="text-center mb-5">
            <button
              class="bg-darkGray hover:bg-lightGray text-xl py-1 px-20 m-2 rounded-full"
              v-on:click="
                (notice_of_privacy_type =
                  'plan_costos_v200501_recibi_reglamento_si'),
                  (acceptConditions = true)
              "
            >
              Sí
            </button>
            <button
              class="bg-darkGray hover:bg-lightGray text-xl py-1 px-20 m-2 rounded-full"
              v-on:click="
                (notice_of_privacy_type =
                  'plan_costos_v200501_recibi_reglamento_no'),
                  (acceptConditions = false)
              "
            >
              No
            </button>
          </div>

          <div class="text-center">
            <p class="text-goodGreen text-2xl font-semibold">Firma Digital</p>
            <p class="px-5">
              Realice su firma como en su identificación oficial
            </p>
          </div>

          <div class="w-full mt-5">
            <div class="flex flex-col lg:flex-row justify-center">
              <div class="w-full flex justify-center text-brown">
                <VueSignaturePad
                  id="signature"
                  width="45%"
                  height="150px"
                  ref="signaturePad"
                  class="border-solid"
                />
              </div>
            </div>

            <div class="text-center mt-5 mb-5">
              <button
                class="mt-5 bg-darkGray hover:bg-lightGray text-xl py-1 px-20 rounded-full"
                @click="undo"
              >
                Deshacer
              </button>
            </div>
          </div>

          <div class="text-center px-5" v-if="acceptConditions == false">
            <span class="text-red-600 text-xl font-semibold"
              >Debes aceptar las condiciones del Aviso de Privacidad para
              continuar</span
            >
          </div>

          <div class="text-center px-5" v-if="showMsgSign == true">
            <span class="text-red-600 text-xl font-semibold"
              >Ingrese la firma</span
            >
          </div>

          <div class="text-center px-5" v-if="document_signed == true">
            <span class="text-red-600 text-xl font-semibold"
              >El documento ya ha sido firmado</span
            >
          </div>

          <div
            class="flex justify-center w-full mt-10 mb-5"
            v-if="loading_finish"
          >
            <propagate-loader
              class="w-full flex justify-center spinner"
              color="#9D4536"
              :loading_finish="loading_finish"
              :size="50"
            ></propagate-loader>
          </div>

          <div class="text-center mt-5 mb-5" v-if="show_finish">
            <button
              @click="goToPDF"
              class="bg-normalYellow hover:bg-hoverYellow text-white text-xl py-1 px-20 rounded-full"
            >
              Finalizar
            </button>
          </div>
        </div>
      </div>
      <!-- Beneficiarios por fallecimiento del Socio SECCION END -->
    </div>
    <div v-else-if="is_url_expiration == true || url_signed == true">
      <div class="bg-goodGreen mt-2 lg:mt-5">
        <span
          class="text-white font-semibold ml-5 lg:ml-20 xl:ml-20 text-3xl md:text-4xl lg:text-4xl xl:text-4xl"
          >{{ errors }}</span
        >
      </div>
    </div>
  </div>
</template>
<script>
//import data_partner from "../assets/data.json";
export default {
  name: "Home",
  data() {
    return {
      acceptConditions: false,
      options: {
        penColor: "#1F2933",
      },
      apiCabsaCore: "https://www.cabsacore.com/",
      apiCcapi: "https://api.cabsacore.com/",//"http://200.92.206.58:8080/",
      //apiCabsaCore: "http://localhost:3000/",
      //apiCabsaCore: "http://200.92.206.58/",
      token_auth_valid: "",
      loading_finish: false,
      show_finish: true,
      is_previous_letter: false,
      is_new_letter: false,
      is_url_expiration: false,
      url_is_expiration: null,
      errors: null,
      url_response_json: null,
      url_response_pdf: null,
      url_path_response_json: null,
      url_path_response_pdf: null,
      name_catalog_document: "",
      url_path_response_pdf_signed: null,
      notice_of_privacy_type: "",
      is_not_document_signed: true,
      urlParams: null,
      file: null,
      json_file: null,
      data: null,
      document_type: "plan_costos_v200501",
      url_for_download_pdf: "",
      document_signed: false,
      loading: false,
      rfc: "",
      name: "",
      gender: "",
      email: "",
      phone: "",
      email_associate: "",
      //variables
      basic_until_70: "",
      basic_ammount_fortnightly: "",
      basic_accept: "",
      basic_from_70: "",
      covid_ammount_fortnightly: "",
      covid_accept: "",
      collateral_ammount_fortnightly: "",
      collateral_bonus_annual_accept: "",
      collateral_bonus_annual: "",
      collateral_bonus_description: "",
      collateral_prothesis_accept: "",
      collateral_prothesis: "",
      collateral_prothesis_description: "",
      collateral_glasses_accept: "",
      collateral_glasses: "",
      collateral_glasses_description: "",
      collateral_lost_organic_accept: "",
      collateral_lost_organic: "",
      collateral_expenses_funeral_accept: "",
      cancer_partner_modules: "",
      cancer_partner_protection: "",
      cancer_partner_date_register: "",
      cancer_partner_ammount_fortnightly: "",
      cancer_economic_dependients: [],
      cancer_observations: "",
      eg_partner_modules: "",
      eg_partner_protection: "",
      eg_partner_date_register: "",
      eg_partner_ammount_fortnightly: "",
      benefits: [],
      ammount_total_benefits: "",
      gastos_funerarios_aportacion_quincenal: "",
      gastos_funerarios_suma_asegurada: "",
      wroteSign: false,
      showMsgSign: false,

      savings_info: "",
      retirement_amount: "",
      death_info: "",
      death_amount: "",
      death_partner_benefit: "",
      death_family_benefit: "",
      death_recovery: "",
      death_vap: "",
      death_disability: "",
      death_benefit: "",
      benefits_vt: [],
      beneficiariesDecease: [],
      cancer_protection: "",
      cancer_contribution: "",
      cancer_acquisition_date: "",
      ge_info: "",
      contribution_info: "",
      total_contribution: "",
      aditionalBenefit: "Defunción",
      benefit: "Beneficio",
      compensation: {},
      //refactoring
      partner_data: [],
      benefits_covid19: [],
      url_signed: false,
      member_id: 0,
      user_id: 0
    };
  },
  methods: {
    encriptarMensaje() {
      const header = { alg: "HS256", typ: "JWT" };
      const encodedHeader = Buffer.from(JSON.stringify(header)).toString(
        "base64"
      );
      var data = {
        html:
          "Informacion del interesado<br>Nombre: " +
          this.name +
          "<br>Correo: " +
          this.email +
          "<br>Celular: " +
          this.phone +
          "<br><br><br>",
      };
      const encodedPayload = Buffer.from(JSON.stringify(data)).toString(
        "base64"
      );
      var jwtSecret = "u3E*aWShrxOv";
      const crypto = require("crypto");
      const signature = crypto
        .createHmac("sha256", jwtSecret)
        .update(encodedHeader + "." + encodedPayload)
        .digest("base64");
      return encodedHeader + "." + encodedPayload + "." + signature;
    },
    async goToPDF() {
      this.show_finish = false;
      this.loading_finish = true;
      this.save();
      if (this.acceptConditions == true) {
        if (this.wroteSign == true) {
          await this.insertDigitalSignatureToFile();
          await this.postUploadFile();
          if (this.is_not_document_signed == true) {
            await this.sendEmail();
            localStorage.setItem("pdf_for_download", this.url_for_download_pdf);
            this.$router.push({ name: "successful-process" });
          }
          this.document_signed = true;
          this.showMsgSign = false;
        } else {
          this.document_signed = false;
          this.showMsgSign = true;
        }
      }
      this.loading_finish = false;
      this.show_finish = true;
    },
    undo() {
      //método para deshacer firma
      this.$refs.signaturePad.undoSignature();
    },
    save() {
      //método para guardar la firma
      const { isEmpty, data } = this.$refs.signaturePad.saveSignature();
      if (isEmpty) {
        this.wroteSign = false;
        return {
          isEmpty: isEmpty,
          data: data,
        };
      } else {
        this.wroteSign = true;
        return {
          isEmpty: isEmpty,
          data: data.split(",")[1],
        };
      }
    },
    change() {
      this.options = {
        penColor: "#1F2933",
      };
    },
    resume() {
      this.options = {
        penColor: "#1F2933",
      };
    },
    async insertDigitalSignatureToFile() {

      let base64_signature = this.save().data
      this.registerSignature(base64_signature)
      
      this.errors = null;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        path_file_to_sign: this.url_path_response_pdf,
        business_acronym: "FOMAPO",
        name_catalog_document: this.name_catalog_document,
        name_catalog_document_notice_of_privacy: this.notice_of_privacy_type,
        digital_signature: base64_signature,
      };
      await this.axios
        .post(this.apiCcapi + "/digital_signatures/insert_digital_signature_to_file",data,config)
        .then((response) => {
          if (response.data.errors.length == 0) {
            this.url_path_response_pdf_signed = response.data.response.path;
          } else {
            this.errors = true;
          }
          this.loading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false;
        });
    },
    async registerSignature(base64_signature) {
      this.errors = null;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        signature_file: base64_signature,
        member_id: this.member_id,
        user_id: this.user_id,
        registered: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString()
      };
      await this.axios
        .post(this.apiCcapi + "/fomapo/signature_fondos/create",data,config)
        .then(() => {
        })
        .catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false;
        });
    },
    async getJsonInformation() {
      this.errors = null;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        file_name: this.json_file,
        business_acronym: "FOMAPO",
        process: "generate_plan_costs_json",
      };
      await this.axios
        .post(this.apiCcapi + "/digital_signatures/get_file_cloud", data, config)
        .then((response) => {
          if (response.data.errors.length == 0){
            this.url_response_json = this.apiCcapi + "/digital_signatures/get_tmp_file?path=" + response.data.response.path
            this.getJsonInformationFromUrl();
            this.is_url_expiration = false;
          } else {
            this.errors = response.data.errors
          }
          this.loading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false;
        });
    },
    async getPdfInformation() {
      this.errors = null;
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        file_name: this.file,
        business_acronym: "FOMAPO",
        process: "generate_plan_costs_pdf",
      };
      await this.axios
        .post(this.apiCcapi + "/digital_signatures/get_file_cloud", data, config)
        .then((response) => {
          if (response.data.errors.length == 0){
            this.url_response_pdf = response.data.response.url;
            this.url_path_response_pdf = response.data.response.path;
          } else {
            this.errors = response.data.errors
          }
          this.loading = false;
        })
        .catch((error) => {
          this.errors = error.response.data.errors
          this.loading = false;
        });
    },
    getJsonInformationFromUrl() {
      this.axios.get(this.url_response_json, "", "").then((response) => {
        //let response = { data: data_partner };
        this.email = response.data.correo
        this.partner_data = [
          { label: "R.F.C", value: response.data.rfc },
          { label: "Nombre Completo", value: response.data.nombre_completo },
          { label: "Correo Electrónico", value: response.data.correo },
          { label: "Telefóno", value: response.data.telefono },
        ];
        this.basic_until_70 = response.data.basico.basico_hasta_70;
        this.basic_ammount_fortnightly =
          response.data.basico.basico_aportacion_quincenal;
        this.basic_accept = response.data.basico.basico_acepto;
        this.basic_from_70 = response.data.basico.basico_apartir_70;
        this.benefits_covid19 = {
          "Fallecimiento por COVID": "$50,000.00",
          "Fallecimiento otro motivo": "$25,000.00",
          "Hospitalización por COVID o diagnóstico de Enfermedad grave":
            "$15,000.00",
        };
        this.covid_ammount_fortnightly =
          response.data.covid19.covid19_aportacion_quincenal;
        this.covid_accept = response.data.covid19.covid19_acepto;
        this.collateral_ammount_fortnightly =
          response.data.colaterales.colaterales_aportacion_quincenal;
        this.collateral_bonus_annual_accept =
          response.data.colaterales.colaterales_bono_anual_acepto;
        this.collateral_bonus_annual =
          response.data.colaterales.colaterales_bono_anual;
        this.collateral_bonus_annual_description =
          response.data.colaterales.colaterales_bono_anual_leyenda;
        this.collateral_prothesis_accept =
          response.data.colaterales.colaterales_protesis_acepto;
        this.collateral_prothesis =
          response.data.colaterales.colaterales_protesis;
        this.collateral_prothesis_descripction =
          response.data.colaterales.colaterales_protesis_leyenda;
        this.collateral_glasses_accept =
          response.data.colaterales.colaterales_lentes_acepto;
        this.collateral_glasses = response.data.colaterales.colaterales_lentes;
        this.collateral_glasses_description =
          response.data.colaterales.colaterales_lentes_leyenda;
        this.collateral_lost_organic_accept =
          response.data.colaterales.colaterales_perdida_organica_acepto;
        this.collateral_lost_organic =
          response.data.colaterales.colaterales_perdida_organica;
        this.collateral_expenses_funeral_accept =
          response.data.colaterales.colaterales_perdida_organica_acepto;
        this.benefits = response.data.sobrevivencia;
        this.cancer_partner_modules = response.data.cancer.cancer_socio_modulos;
        this.cancer_partner_protection =
          response.data.cancer.cancer_socio_proteccion;
        this.cancer_partner_date_register =
          response.data.cancer.cancer_socio_fecha_alta;
        this.cancer_partner_ammount_fortnightly =
          response.data.cancer.cancer_socio_aportacion_quincenal;
        this.cancer_economic_dependients =
          response.data.cancer.cancer_dependientes_economicos;
        this.cancer_observations = response.data.cancer.observaciones;
        this.eg_partner_modules =
          response.data.enfermedades_graves.enfermedades_graves_socio_modulos;
        this.eg_partner_protection =
          response.data.enfermedades_graves.enfermedades_graves_socio_proteccion;
        this.eg_partner_date_register =
          response.data.enfermedades_graves.enfermedades_graves_socio_fecha_alta;
        this.eg_partner_ammount_fortnightly =
          response.data.enfermedades_graves.enfermedades_graves_socio_aportacion_quincenal;
        this.beneficiariesDecease =
          response.data.beneficiarios_por_fallecimiento_socio;
        this.ammount_total_benefits = response.data.importe_total_beneficios;
        this.gastos_funerarios_aportacion_quincenal = response.data.gastos_funerarios_aportacion_quincenal;
        this.gastos_funerarios_suma_asegurada = response.data.gastos_funerarios_suma_asegurada;
        
        this.user_id = response.data.usuario_id;
        this.member_id = response.data.socio_id;

        this.name_catalog_document = response.data.nombre_catalogo_documento + "_firma"
      });
    },
    insertDatesToCompensation(compensation) {
      compensation = {
        0: {
          name: "Cáncer",
          aditional: "",
          protection: this.cancer_info.cancer_protection,
          date: this.cancer_info.cancer_acquisition_date,
          cost: this.cancer_info.cancer_contribution,
        },
        1: {
          name: "Enfermedades graves",
          aditional: "",
          protection: this.ge_info.ge_protection,
          date: this.ge_info.ge_acquisition_date,
          cost: this.ge_info.ge_contribution,
        },
      };
      return compensation;
    },
    async postUrlExpiration() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      this.loading = true;
      await this.axios.post(this.apiCcapi + "/digital_signatures/expiry_time",
          {
            token_auth: this.token_auth_valid,
            url: window.location.toString(),
            business_acronym: "FOMAPO",
          },
          config
        )
        .then((response) => {
          if (response.data.errors.length == 0) {
            this.url_is_expiration = false;
            return true;
          }
        })
        .catch((error) => {
          error.response.data.errors;
          this.errors = "El documento que desea firmar ya ha vencido, favor de contactar a su asesor.";
          this.url_is_expiration = true;
          this.is_url_expiration = true;
          return false;
        });
    },
    async validateStatusUrl() {
      this.loading = true;
      const params = {
        token_auth: this.token_auth_valid,
        url: window.location.toString(),
        business_acronym: "FOMAPO",
      };
      await this.axios
        .get(this.apiCcapi + "/digital_signatures/get_status_digital_signature", {
          params,
        })
        .then((response) => {
          if (response.data.response.url_status == "FIRMADO") {
            this.url_signed = true;
            this.errors =
              "El documento que desea firmar ya ha sido firmado, favor de contactar a su asesor.";
          } else {
            this.url_signed = false;
          }
        })
        .catch((error) => {
          console.log("Error: ", error);
          this.url_signed = true;
          this.errors =
            "Se presentó un error al validar el estatus de la url, favor de contactar a su asesor.";
        });
    },
    async postLogin(){
      let config = {
        headers: {
            'Content-Type': 'application/json'
        },
      }

      let data = {
        user: {
          email: "aplm@gcabsa.com.mx",
          password: "cabsa2022",
        },
      };

      await this.axios.post(this.apiCcapi + '/fas/login', data, config)
        .then((dataa) => {
          this.token_auth_valid = dataa.data.token_auth
          localStorage.setItem("token_auth_valid", this.token_auth_valid);
      })
    },
    async sendEmail() {
      let emails = [];

      if (this.email != "") {
        emails.push(this.email);
      }
      if (this.email_associate != "") {
        emails.push(this.email_associate);
      }
      
      let message = this.encriptarMensaje();
      this.axios
        .post(this.apiCcapi + "/send_mail", {
          business: "fomapo",
          mail: {
            business: "fomapo",
            process_type: "firma designacion beneficiarios",
            title: "Firma Digital FOMAPO",
            body_mail: message,
            //"eyJhbGciOiJIUzI1NiJ9.eyJodG1sIjoiIn0.XM6FzZ4J0WG-Y8nAFXKaCBBs8_osDVj7l_viFVHppSo",
            mailing_list: emails,
            attachment_list: [
              {
                file: this.url_for_download_pdf,
                name: "FirmaDigitalFOMAPO.pdf",
              },
            ],
          },
        })
        .then((response) => {
          console.log("SE ENVIO EL EMAIL", response.data);
          // this.sendedEmailConfirmation()
          this.email = "";
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
    async postUploadFile() {
      let config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      let data = {
        token_auth: this.token_auth_valid,
        file: this.url_path_response_pdf_signed,
        document_name: this.document_type,
        business_acronym: "FOMAPO",
        process: "generate_plan_costs_pdf_signed",
        extension: "",
        url_for_sign: window.location.href,
        //"https://firma.autorizo.fomapo.com/?file=dcf7b15d39a9cc5ef02d21f217ab4396.pdf&json_file=5afa1ce1870946b8c0c4d3c8e3a28eb5.json",
      };
      await this.axios
        .post(this.apiCcapi + "/digital_signatures/upload_signed_file", data, config)
        .then((response) => {
          if (response.data.errors.length == 0) {
            this.url_for_download_pdf = response.data.response.url;
          } else {
            this.is_not_document_signed = false;
          }
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
          this.is_not_document_signed = false;
        });
    },
    getPrivacynotice() {
      window.open(
        "https://cabsacloud.ams3.digitaloceanspaces.com/store/FOMAPO/Aviso%20de%20Privacidad%20FOMAPO.pdf"
      );
    },
  },
  async beforeMount() {
    this.urlParams = new URLSearchParams(window.location.search);
    this.file = this.urlParams.get("file");
    this.json_file = this.urlParams.get("json_file");
    await this.postLogin();
    await this.postUrlExpiration();
    if (this.url_is_expiration == false) {
      await this.validateStatusUrl();
    }
    if (this.url_is_expiration == false && this.url_signed == false) {
      this.getJsonInformation();
      this.getPdfInformation();
    }
    this.loading = false;
    this.getJsonInformationFromUrl();
  },
};
</script>
<style scoped>
.partner-col {
  @apply w-full p-2 ml-5;
}
.headers {
  @apply w-full bg-brown p-2 pl-5 text-white font-semibold text-base;
}
.title {
  @apply w-full text-brown text-center;
}
.benefitsFOMAPO-hearders {
  @apply grid grid-cols-2 m-4;
}
.benefitsFOMAPO-hearders-movil {
  @apply text-brown;
}
@screen md {
  .benefitsFOMAPO-hearders-movil {
    @apply inline-grid hidden;
  }
  .benefitsFOMAPO-data {
    @apply inline-grid hidden;
  }
  .headers {
    @apply p-3 pl-5 text-xl;
  }
  .partner-col {
    @apply w-3/12 ml-0 pl-10;
  }
  .benefitsFOMAPO-col {
    @apply w-2/12 ml-0 mr-0 pl-10 pr-10 pt-2;
  }
  .benefitsFOMAPO-hearders {
    @apply grid grid-cols-4 m-4;
  }
  .title {
    @apply w-2/12;
  }
}
hr {
  border-top: 2px solid #9d4536;
}
#signature {
  border: double 2px transparent;
  border-radius: 5px;
  background-image: linear-gradient(white, white),
    radial-gradient(circle at top left, #9d4536, #9d4536);
  background-origin: border-box;
  background-clip: content-box, border-box;
}
@media only screen and (max-width: 650px) {
  .hideInSmallScreens {
    display: none;
  }
}
@media only screen and (min-width: 650px) {
  .showInSmallScreens {
    display: none;
  }
}
</style>